import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { addEditData } from "../../controllers/careers/careers";
import { fetchIpAddress } from "../../controllers/API";

import LoadingEffect from "../../components/Loading/LoadingEffect";
import ReactQuill from 'react-quill';

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  const [isLoading, setIsLoading] = useState(false);

  const [CONTENT, setContent] = useState('');
  const [schoolLevels, setSchoolLevels] = useState(["early", "primary", "middle", "senior"]);
  const [campus, setCampus] = useState(["op-campus", "rr-campus"]);
  const [subjects, setSubjects] = useState(["english", "science", "hindi", "mathematics"]);
  const [experience, setExperience] = useState(["0-1 years", "1-3 years", "3-5 years", "5-10 years"]);
  const [position, setPosition] = useState(["junior", "senior", "administrator"]);

  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };


  const [schoollvlAddEditData, setSchoollvlAddEditData] = useState([]);
  const handleSchoolLvlChange = (value) => {
    setSchoollvlAddEditData(value);
    setError((preError) => ({
      ...preError,
      page: "",
    }));
  };
  const schoolLevelsOptions = schoolLevels.map((page) => ({
    value: page,
    label: page,
  }));

  const [campusAddEditData, setCampusAddEditData] = useState([]);
  const handleCampusChange = (value) => {
    setCampusAddEditData(value);
    setError((preError) => ({
      ...preError,
      page: "",
    }));
  };
  const campusOptions = campus.map((page) => ({
    value: page,
    label: page,
  }));

  const [subjectAddEditData, setSubjectAddEditData] = useState([]);
  const handleSubjectsChange = (value) => {
    setSubjectAddEditData(value);
    setError((preError) => ({
      ...preError,
      page: "",
    }));
  };
  const subjectOptions = subjects.map((page) => ({
    value: page,
    label: page,
  }));

  const [experienceAddEditData, setExperienceAddEditData] = useState([]);
  const handleExperienceChange = (value) => {
    setExperienceAddEditData(value);
    setError((preError) => ({
      ...preError,
      page: "",
    }));
  };
  const experienceOptions = experience.map((page) => ({
    value: page,
    label: page,
  }));

  const [positionAddEditData, setPositionAddEditData] = useState([]);
  const handlePositionChange = (value) => {
    setPositionAddEditData(value);
    setError((preError) => ({
      ...preError,
      page: "",
    }));
  };
  const positionOptions = position.map((page) => ({
    value: page,
    label: page,
  }));

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        job_title,
        content,
        campus,
        school_level,
        position,
        subject,
        experience,
      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      }
      form.append("job_title", job_title);
      form.append("content", CONTENT);
      form.append("campus", campusAddEditData);
      form.append("school_level", schoollvlAddEditData);
      form.append("position", positionAddEditData);
      form.append("subject", subjectAddEditData);
      form.append("experience", experienceAddEditData);
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      if (isValidate) {
        const rawData = {
          edit_id : _id,
          job_title  : job_title,
          content : CONTENT,
          campus : campusAddEditData,
          school_level : schoollvlAddEditData,
          position : positionAddEditData,
          subject : subjectAddEditData,
          experience : experienceAddEditData,
          ipAddress : ipAddress,
        };
        const options = {
          url: `careers/addeditdata`,
          postData: rawData,
        };
        const res = await addEditData(options);
        if (res.status === true) {
          notification.open({
            message: "Data added.",
            description: `Data added Successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/careers");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };


  const validateFormData = (form) => {
    if (!form.get("job_title").trim() || form.get("job_title").trim() === "undefined" || form.get("job_title").trim() === null) {
      setError((preError) => ({
        ...preError,
        job_title: "Job title is required",
      }));
      return false;
    }
    if (!form.get("content").trim() || form.get("content").trim() === "undefined" || form.get("content").trim() === null) {
      setError((preError) => ({
        ...preError,
        content: "Content is required",
      }));
      return false;
    }
    // if (!form.get("campus") || form.get("campus") === "undefined" || form.get("campus") === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     campus: "Campus is required",
    //   }));
    //   return false;
    // }
    // if (!form.get("school_level") || form.get("school_level") === "undefined" || form.get("school_level") === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     school_level: "School level is required",
    //   }));
    //   return false;
    // }
    // if (!form.get("position") || form.get("position") === "undefined" || form.get("position") === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     position: "Position is required",
    //   }));
    //   return false;
    // }
    // if (!form.get("subject") || form.get("subject") === "undefined" || form.get("subject") === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     subject: "Subject is required",
    //   }));
    //   return false;
    // }
    // if (!form.get("experience") || form.get("experience") === "undefined" || form.get("experience") === null) {
    //   setError((preError) => ({
    //     ...preError,
    //     experience: "Experience is required",
    //   }));
    //   return false;
    // }
    return true;
  };




  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    if(ADDEDITDATA?._id){
      setContent(ADDEDITDATA?.content);
      setSchoollvlAddEditData(ADDEDITDATA?.school_level);
      setCampusAddEditData(ADDEDITDATA?.campus);
      setSubjectAddEditData(ADDEDITDATA?.subject);
      setExperienceAddEditData(ADDEDITDATA?.experience);
      setPositionAddEditData(ADDEDITDATA?.position);
    }
    document.title = `KC High Super Admin || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Career`;
  }, [ADDEDITDATA]);
  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Career
            </h5>
          </div>
          <Link to="/careers">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row">
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="job_title"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Job Title :{" "}
                    </label>
                    <input
                      title="Enter job title"
                      placeholder="Enter job title"
                      type="text"
                      name="job_title"
                      className="form-control store_input_field"
                      id="job_title"
                      value={ADDEDITDATA?.job_title}
                      onChange={handleChange}
                    />
                    {error.job_title ? (
                      <p style={{ color: "red" }}>
                        {error.job_title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="content"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Content :
                    </label>
                    <ReactQuill
                      theme="snow"
                      value={CONTENT || ''}
                      onChange={setContent}
                    />
                    {error.content ? (
                      <p style={{ color: "red" }}>{error.content}</p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                  <label htmlFor="school_level">Select school level : </label>
                  <Select
                    mode="multiple"
                    placeholder="Select school level"
                    variant="school_level"
                    name="school_level"
                    className="form-control store_input_field mt-2"
                    style={{ flex: 1 }}
                    value={schoollvlAddEditData}
                    onChange={handleSchoolLvlChange}
                    options={schoolLevelsOptions}
                  />
                  {error.school_level ? (
                    <p style={{ color: "red" }}>{error.school_level}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                  <label htmlFor="campus">Select campus : </label>
                  <Select
                    mode="multiple"
                    placeholder="Select campus"
                    variant="campus"
                    name="campus"
                    className="form-control store_input_field mt-2"
                    style={{ flex: 1 }}
                    value={campusAddEditData}
                    onChange={handleCampusChange}
                    options={campusOptions}
                  />
                  {error.campus ? (
                    <p style={{ color: "red" }}>{error.campus}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                  <label htmlFor="subject">Select subjects : </label>
                  <Select
                    mode="multiple"
                    placeholder="Select subject"
                    variant="campus"
                    name="campus"
                    className="form-control store_input_field mt-2"
                    style={{ flex: 1 }}
                    value={subjectAddEditData}
                    onChange={handleSubjectsChange}
                    options={subjectOptions}
                  />
                  {error.campus ? (
                    <p style={{ color: "red" }}>{error.campus}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                  <label htmlFor="experience">Select experience : </label>
                  <Select
                    mode="multiple"
                    placeholder="Select experience"
                    variant="experience"
                    name="experience"
                    className="form-control store_input_field mt-2"
                    style={{ flex: 1 }}
                    value={experienceAddEditData}
                    onChange={handleExperienceChange}
                    options={experienceOptions}
                  />
                  {error.experience ? (
                    <p style={{ color: "red" }}>{error.experience}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                  <label htmlFor="position">Select position : </label>
                  <Select
                    mode="multiple"
                    placeholder="Select position"
                    variant="position"
                    name="position"
                    className="form-control store_input_field mt-2"
                    style={{ flex: 1 }}
                    value={positionAddEditData}
                    onChange={handlePositionChange}
                    options={positionOptions}
                  />
                  {error.position ? (
                    <p style={{ color: "red" }}>{error.position}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
